// 콘텐츠, 챌린지, 체크

import { apiClient } from "./axios";

const challengeList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/challenge/list?page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeCreate = async ({
  challengeTitle,
  challengeCertification,
  challengeFrequency,
  challengeDaily,
  challengeMax,
  challengeAuthCnt,
  challengeIcon,
  challengeAuthDescription,
  challengeDescription,
  challengeStart,
  challengeEnd,
  IsPrivate,
  ChallengeWeeklyAuth,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/challenge/create", {
      challenge_title: challengeTitle,
      challenge_certification: challengeCertification,
      challenge_frequency: challengeFrequency,
      challenge_daily: challengeDaily,
      challenge_max: challengeMax,
      challenge_auth_cnt: challengeAuthCnt,
      challenge_icon: challengeIcon,
      challenge_auth_description: challengeAuthDescription,
      challenge_description: challengeDescription,
      challenge_start: challengeStart,
      challenge_end: challengeEnd,
      is_private: IsPrivate,
      challenge_weekly_auth: ChallengeWeeklyAuth,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeUpdate = async ({
  id,
  challengeTitle,
  challengeCertification,
  challengeFrequency,
  challengeDaily,
  challengeMax,
  challengeAuthCnt,
  challengeIcon,
  challengeAuthDescription,
  challengeDescription,
  challengeStart,
  challengeEnd,
  IsPrivate,
  ChallengeWeeklyAuth,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/challenge/update", {
      id: id,
      challenge_title: challengeTitle,
      challenge_certification: challengeCertification,
      challenge_frequency: challengeFrequency,
      challenge_daily: challengeDaily,
      challenge_max: challengeMax,
      challenge_auth_cnt: challengeAuthCnt,
      challenge_icon: challengeIcon,
      challenge_auth_description: challengeAuthDescription,
      challenge_description: challengeDescription,
      challenge_start: challengeStart,
      challenge_end: challengeEnd,
      is_private: IsPrivate,
      challenge_weekly_auth: ChallengeWeeklyAuth,
    });
    console.log(ChallengeWeeklyAuth, res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/challenge/delete", {
      challenge_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQAList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/qna/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQADelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/delete", {
      qa_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentCreate = async ({
  id,
  qaComment,
  qaCommentReferImage,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/create", {
      qa_id: id,
      qa_comment: qaComment,
      qa_comment_refer_image: qaCommentReferImage,
    });
    console.log(res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentList = async ({ id }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/qna/comment/list?qa_id=${id}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/delete", {
      id: id,
    });
    console.log(res, "111");
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentUpdate = async ({
  id,
  qaComment,
  qaCommentReferImage,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/update", {
      id: id,
      qa_comment: qaComment,
      qa_comment_refer_image: qaCommentReferImage,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/content/list?filter=""&page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};
const storyList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/story/list?filter=""&page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsCreate = async ({
  authorId,
  contentTitle,
  contentDescription,
  contentThumbnail,
  contentBackgroundImage,
  contentType, // 이 값이 실제로는 content_type임
}) => {
  try {
    console.log("contentType : ",contentType)
    const res = await apiClient.post("/api/v1/admin/content/create", {
      author_id: authorId,
      content_title: contentTitle,
      content_description: contentDescription,
      content_thumbnail: contentThumbnail,
      content_background_image: contentBackgroundImage,
      content_type: contentType, // 드롭다운에서 선택한 값
    });

    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }

    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsUpdate = async ({
  id,
  authorId,
  contentTitle,
  contentDescription,
  contentThumbnail,
  contentBackgroundImage,
  contentType,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/update", {
      id,
      author_id: authorId,
      content_title: contentTitle,
      content_description: contentDescription,
      content_thumbnail: contentThumbnail,
      content_background_image: contentBackgroundImage,
      content_type: contentType,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};


const contentsDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/delete", {
      content_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsGroupList = async () => {
  try {
    const res = await apiClient.get(
      "/api/v1/admin/content/group/list/temporary"
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsGroupCreate = async ({
  contentGroupName,
  groupThumbnail,
  groupTag,
  groupBackground,
}) => {
  try {
    const res = await apiClient.post(
      "/api/v1/admin/content/group/create/temporary",
      {
        content_group_name: contentGroupName,
        group_thumbnail: groupThumbnail,
        group_background: groupBackground,
        group_tag: groupTag,
      }
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsImageUpload = async ({ base64Image }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/image/temporary", {
      image: base64Image,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsAuthorList = async () => {
  try {
    const res = await apiClient.get("/api/v1/admin/list");
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const binaryContentsHooks = {
  contentsAuthorList,
  challengeList,
  challengeCreate,
  challengeUpdate,
  challengeDelete,
  expertQAList,
  expertQADelete,
  expertQACommentList,
  expertQACommentCreate,
  expertQACommentUpdate,
  expertQACommentDelete,
  contentsList,
  contentsCreate,
  contentsDelete,
  contentsGroupCreate,
  contentsGroupList,
  contentsUpdate,
  contentsImageUpload,
  storyList,
};
export default binaryContentsHooks;
